// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PArrowLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PArrowLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PArrowLeftOutlined = function PArrowLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PArrowLeftOutlinedSvg
  }));
};

PArrowLeftOutlined.displayName = 'PArrowLeftOutlined';
export default React.forwardRef(PArrowLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PArrowLeftOutlined.js
// module id = 3216
// module chunks = 0